//  import { Link } from 'react-router-dom';

const podcasts = [
  {
    id: 1,
    title: "What is Alfa Entrepreneur Community?",
    description: "A deep dive into the Alfa Entrepreneur ...",
    thumbnail: "HeroThumbnail.png",
    duration: "01:26sec",
    video: "HeroVideo.mp4" // Path to the local video file
  },
  {
    id: 2,
    title: "How to Build a Successful Business?",
    description: "Learn the key strategies to grow your business...",
    thumbnail: "SocialThumbnail.png",
    duration: "00:39sec",
    video: "SocialVideo.mp4" // Path to the local video file
  },
  {
    id: 3,
    title: "Teamwork and Fellowship in Business",
    description: "The importance of teamwork in entrepreneurship...",
    thumbnail: "HV3Thumbnail.png",
    duration: "01:27sec",
    video: "HomeVideo3.mp4" // Path to the local video file
  },
  {
    id: 4,
    title: "Marketing Strategies for Startups",
    description: "Effective marketing strategies for new businesses...",
    thumbnail: "MarketingThumbnail.png",
    duration: "01:10sec",
    video: "MarketingVideo.mp4" // Path to the local video file
  },
  // {
  //   id: 5,
  //   title: "Networking for Entrepreneurs",
  //   description: "How to build a strong network as an entrepreneur...",
  //   thumbnail: "NetworkingThumbnail.png",
  //   duration: "00:50sec",
  //   video: "NetworkingVideo.mp4" // Path to the local video file
  // },
];

export default function PodcastPage() {
  return (
     <div className="max-w-7xl mx-auto px-8 sm:px-10 lg:px-8 py-12">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-14">
        {podcasts.map((podcast) => (
          <div key={podcast.id} className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">{podcast.title}</h2>
            <p className="text-gray-600 mb-4">{podcast.description}</p>
            {podcast.video ? (
              <video
                controls
                className="w-full rounded-lg shadow-lg mb-4"
                src={podcast.video}
                title={podcast.title}
                poster={podcast.thumbnail} // Use thumbnail as poster image
              />
            ) : (
              <img
                src={podcast.thumbnail}
                alt={podcast.title}
                className="w-full rounded-lg shadow-lg mb-4"
              />
            )}
            <p className="text-sm text-gray-500">Duration: {podcast.duration}</p>
          </div>
        ))}
      </div>
       {/* <div className="hidden md:block w-full md:w-1/3 pl-4">
        <div className="bg-white shadow-lg p-4 rounded-lg">
          <h2 className="text-xl font-bold mb-4">Other Podcasts</h2>
          <ul className="list-disc list-inside">
            {podcasts.map((podcast) => (
              <li key={podcast.id} className="mb-2">
                <a href={`#podcast-${podcast.id}`} className="text-blue-500 hover:underline">
                  {podcast.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>  */}
    </div>
  );
}